import { workersPoolsService } from 'ogp/services';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { OGP } from '@levelworks/shared-backend-api';

export const useGetExternalWorkersPoolDetail = (id: string) => {
  const queryFn = async () => await workersPoolsService.getWorkersPoolDetail({ id });

  return useQuery<OGP.GetWorkersPoolResponseDto, Error>(
    QUERY_KEYS.externalWorkersPoolDetail(id),
    queryFn,
    { enabled: id.length > 0 }
  );
};
